import RestClient from './../../service/rest-client';
import {Signal} from 'signals';

class Service {

    event = {
        onFetchCountryStatsByRevenue: new Signal(),
        onFetchUTMSourceForCountryByRevenue: new Signal(),
    };

    fetchUtmSourceForCountryByRevenueDay(intervalDates) {
        intervalDates = intervalDates || 1;

        RestClient.isSessionActive();
        var queryParams = [`interval_days=${ intervalDates }`];

        var urlRequestTemplate = "/reporting/countrystats/bysource?" + queryParams.join("&");

        return RestClient.getRequest(urlRequestTemplate,"").then((data) => {
            var page = data.page_number;
            var pageSize = data.page_size,
                offset = (page - 1) * pageSize;
            var pagingMetadata = {
                page: data.page_number,
                startIndex: offset + 1,
                endIndex: offset + pageSize,
                totalCount: data.total_count,
                pageCount: Math.max(Math.ceil(data.total_count / pageSize), 1)//Always 1 page, even if 0 results
            };
            data.pagingMetadata = pagingMetadata;
            data.results = this.parseUTMSourceForCountryByRevenue(data.results);
            this.event.onFetchUTMSourceForCountryByRevenue.dispatch(data);
        }).catch((error) => {
            console.log("Error: " + error);
        });
    }

    parseUTMSourceForCountryByRevenue(resultData) {
        var parsedArray = resultData.map(function(dataItem) {
            var parsedObject = {};
            parsedObject.id = dataItem.id;
            parsedObject.utmsource = (dataItem.utmsource).replace(/first:|last:/gi, '');
            parsedObject.countryName = dataItem.countryName;

            return parsedObject;
        });
        return parsedArray;
    }

    // start country histogram by revenue
    fetchCountryStatsByRevenue(intervalDays) {
        RestClient.isSessionActive();
        var queryParams = [`interval_days=${ intervalDays }`];
        var urlRequestTemplate = "/reporting/countrystats/byrevenue?" + queryParams.join("&");

        return RestClient.getRequest(urlRequestTemplate,"").then( (data) => {
            var chartData = this.parseRevenueDataBySubject(data.results[0]);
            this.event.onFetchCountryStatsByRevenue.dispatch(chartData);
        }).catch((error) => {
            console.log("Error: " + error);
        });
    }

    parseRevenueDataBySubject(resultData) {
        var chartData = {
            categoryList : [],
            revenueSeriesData: [],
            signUpSeriesData: [],
            packageSeriesData: [],
            newPackageSeriesData: [],
            shipmentSeriesData: [],
            newShipmentSeriesData: [],
        };

        resultData.signUpAndRevenueSeries.forEach(function(dataItem) {
            chartData.categoryList.push(dataItem.countryName);
            chartData.revenueSeriesData.push(dataItem.revenue);
            chartData.signUpSeriesData.push(dataItem.signUpCount);
        });

        resultData.packageSeries.forEach(function(dataItem) {
            chartData.packageSeriesData.push(dataItem.packageCount);
            chartData.newPackageSeriesData.push(dataItem.newPackagesCount);
        });

        resultData.shipmentSeries.forEach(function(dataItem) {
            chartData.shipmentSeriesData.push(dataItem.shipmentCount);
            chartData.newShipmentSeriesData.push(dataItem.newShipmentsCount);
        });

        return chartData;
    }
}

export default new Service();